import React, { useState } from 'react';
import styles from './ContactSupportButtons.module.css';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import classNames from 'classnames';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import {
  CustomerServiceOutlined,
  MobileOutlined,
  SendOutlined,
} from '@ant-design/icons';
import { HelpCenter } from '../../../../../common/components/HelpCenter/HelpCenter';
import { Overlay } from '@mm/components/src/Overlay/Overlay';
import { ContactSupport } from '../ContactSupport';
import { SendToDeveloper } from '../SendToDeveloper';
import { useResolutionInfo } from '@mm/hooks';
import { MOBILE_SMALL } from '../../../../../editor/constants/screenSize';

type Props = {
  promoter: PromoterModel;
  helpLink?: string;
  canSkip?: boolean;
  onClick?: () => void;
  onSkipClick?: () => void;
  className?: string;
};

export const ContactSupportButtons = ({
  promoter,
  helpLink,
  canSkip,
  onClick,
  onSkipClick,
  className,
}: Props) => {
  const [showContactSupport, setShowContactSupport] = useState<
    'email' | 'phone' | 'thankYou' | undefined
  >(undefined);
  const [showSendToDeveloper, setShowSendToDeveloper] = useState(false);

  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_SMALL;

  return (
    <>
      <div className={classNames(styles.footer, styles.column, className)}>
        <div className={styles.text}>Having trouble?</div>
        <div className={classNames(styles.footerButtons, styles.row)}>
          {!isMobile && promoter && (
            <PrimaryButton
              className={styles.primaryButton}
              onClick={() => setShowContactSupport('email')}
            >
              <CustomerServiceOutlined />
              Schedule a guided installation
            </PrimaryButton>
          )}
          {promoter && (
            <PrimaryButton
              className={styles.primaryButton}
              onClick={() => setShowContactSupport('phone')}
            >
              <MobileOutlined />
              Call me now
            </PrimaryButton>
          )}
          {!isMobile && promoter && canSkip && (
            <div className={styles.text}>or</div>
          )}
          {promoter && (
            <PrimaryButton
              className={classNames(styles.primaryButton)}
              onClick={() => setShowSendToDeveloper(true)}
            >
              <SendOutlined />
              Send this to my developer
            </PrimaryButton>
          )}
          {canSkip && onSkipClick && (
            <PrimaryButton
              className={classNames(styles.primaryButton, {
                [styles.secondaryButton]: !isMobile,
              })}
              onClick={onSkipClick}
            >
              {isMobile ? 'Skip for now' : 'Skip'}
            </PrimaryButton>
          )}
          {!isMobile && helpLink && (
            <HelpCenter helpLink={helpLink} className={styles.helpCenter} />
          )}
        </div>
      </div>
      {showContactSupport && promoter && (
        <Overlay className={styles.overlay}>
          <ContactSupport
            type={showContactSupport}
            promoter={promoter}
            setShowContactSupport={setShowContactSupport}
            onClick={onClick}
          />
        </Overlay>
      )}
      {showSendToDeveloper && promoter && (
        <Overlay className={styles.overlay}>
          <SendToDeveloper
            promoter={promoter}
            onClick={onClick}
            onClose={() => setShowSendToDeveloper(false)}
          />
        </Overlay>
      )}
    </>
  );
};
